import { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const BrandsSection = () => {
  const { t } = useLanguage();
  
  const brands = [
    // Première ligne (gauche -> droite)
    ['iPhone', 'Samsung', 'Google', 'Xiaomi', 'OnePlus', 'Huawei', 'Motorola', 'Redmi', 'Oppo', 'Sony', 'Nokia', 'Asus', 'Dell', 'Acer'],
    // Deuxième ligne (droite -> gauche)
    ['ZTE', 'TCL', 'Tecno', 'Google Pixel', 'Lenovo', 'HP', 'JBL', 'Amazon', 'Microsoft', 'LG', 'HTC', 'Vivo', 'Realme', 'Honor'],
    // Troisième ligne (gauche -> droite)
    ['Apple Watch', 'Galaxy Watch', 'Starlink', 'PS4', 'PS5', 'AirPods', 'Backup', 'Router', 'Smart Home', 'Fitness Tracker', 'Drone', 'VR Headset', 'Smart TV', 'E-Reader'],
  ];

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const section = document.getElementById('brands-section');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section id="brands-section" className="py-16 bg-gradient-to-b from-red-950 via-red-900 to-red-950 overflow-hidden font-inter">
      <div className="container mx-auto px-4">
        {/* Titre */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('brandsTitle')}
            {' '}<span className="text-red-300">MichelCell</span>
          </h2>
          <p className="text-red-100 text-lg max-w-2xl mx-auto">
            {t('brandsDesc')}
          </p>
        </div>

        {/* Conteneur des bandes animées */}
        <div className="space-y-6">
          {/* Première bande (gauche -> droite) */}
          <div className={`flex space-x-8 ${isVisible ? 'animate-scroll-right' : ''}`}>
            {[...brands[0], ...brands[0]].map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4 border border-white/30 hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:border-red-200"
              >
                <span className="text-white font-semibold text-lg whitespace-nowrap">
                  {brand}
                </span>
              </div>
            ))}
          </div>

          {/* Deuxième bande (droite -> gauche) */}
          <div className={`flex space-x-8 ${isVisible ? 'animate-scroll-left' : ''}`}>
            {[...brands[1], ...brands[1]].map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4 border border-white/30 hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:border-red-200"
              >
                <span className="text-white font-semibold text-lg whitespace-nowrap">
                  {brand}
                </span>
              </div>
            ))}
          </div>

          {/* Troisième bande (gauche -> droite) */}
          <div className={`flex space-x-8 ${isVisible ? 'animate-scroll-right' : ''}`}>
            {[...brands[2], ...brands[2]].map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-4 border border-white/30 hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:border-red-200"
              >
                <span className="text-white font-semibold text-lg whitespace-nowrap">
                  {brand}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Stats ou informations supplémentaires */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm border border-white/30 hover:border-red-200 transition-all duration-300 hover:scale-[1.02]">
            <div className="text-3xl font-bold text-red-200 mb-2">50+</div>
            <div className="text-red-100">
              {t('brandStatsBrands')}
            </div>
          </div>
          <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm border border-white/30 hover:border-red-200 transition-all duration-300 hover:scale-[1.02]">
            <div className="text-3xl font-bold text-red-200 mb-2">1000+</div>
            <div className="text-red-100">
              {t('aboutStatsProd')}
            </div>
          </div>
          <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm border border-white/30 hover:border-red-200 transition-all duration-300 hover:scale-[1.02]">
            <div className="text-3xl font-bold text-red-200 mb-2">
              {t('brandStatsExpert')}
            </div>
            <div className="text-red-100">
              {t('brandStatsSupport')}
            </div>
          </div>
        </div>
      </div>

      {/* Styles d'animation */}
      <style jsx global>{`
        @keyframes scrollRight {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        @keyframes scrollLeft {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }

        .animate-scroll-right {
          animation: scrollRight 30s linear infinite;
        }

        .animate-scroll-left {
          animation: scrollLeft 30s linear infinite;
        }

        /* Pause l'animation au survol */
        .animate-scroll-right:hover,
        .animate-scroll-left:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default BrandsSection;